export const tenantMeilisearchSearchKeyKeys = {
  all: ["tenant-meilisearch-search-key"] as const,
  details: () => [...tenantMeilisearchSearchKeyKeys.all, "detail"] as const,
  detail: (directoryToken: string) =>
    [...tenantMeilisearchSearchKeyKeys.details(), directoryToken] as const,
};
